module.exports = __webpack_public_path__ + "img/blessing.3fa80615.png";